import { Routes } from '@angular/router';

export const TEAM_ROUTES: Routes = [
    {
        path: 'dashboard',
        pathMatch: 'full',
        data: { section: 'TEAM_DASHBOARD_SECTION' },
        loadChildren: () => import('@app/client/account/team/dashboard/dashboard.module').then(m => m.DashboardModule),
    },
    {
        path: 'promotions',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/team/promotion/promotion.module').then(m => m.PromotionModule),
    },
    {
        path: 'customization',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/team/customization/customization.module').then(m => m.CustomizationModule),
    },
    {
        path: 'members',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/team/members/members.module').then(m => m.MembersModule),
    },
    {
        path: 'groups',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/team/groups/groups.module').then(m => m.GroupsModule),
    },
    {
        path: 'guests',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/team/guests/guests.module').then(m => m.GuestsModule),
    },
    {
        path: 'transfers/sent',
        pathMatch: 'prefix',
        data: { section: 'TEAM_TRANSFERS_SECTION' },
        loadChildren: () => import('@app/client/account/team/transfers/transfers-sent/transfers-sent.module').then(m => m.TransfersSentModule),
    },
    {
        path: 'transfers/received',
        pathMatch: 'prefix',
        data: { section: 'TEAM_TRANSFERS_SECTION' },
        loadChildren: () => import('@app/client/account/team/transfers/transfers-received/transfers-received.module').then(m => m.TransfersReceivedModule),
    },
    {
        path: 'transfers/deleted',
        pathMatch: 'prefix',
        data: { section: 'TEAM_TRANSFERS_SECTION' },
        loadChildren: () => import('@app/client/account/team/transfers/transfers-deleted/transfers-deleted.module').then(m => m.TransfersDeletedModule),
    },
    {
        path: 'settings',
        pathMatch: 'prefix',
        data: { section: 'TEAM_SETTINGS_SECTION' },
        loadChildren: () => import('@app/client/account/team/settings/settings.module').then(m => m.SettingsModule),
    },
];
